import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import SvgProfile from '../../../../../play-core/icons/Profile';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { useLoginState } from '../../../providers/DataProvider/DataContext';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RTSLoginProfile = () => {
  const {
    profile: {
      firstName
    }
  } = useLoginState();
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgProfile, {}),
      size: 40,
      color: Colors.GREY_969696
    }), /*#__PURE__*/_jsxs(PersonalSection, {
      children: [/*#__PURE__*/_jsxs(Greeting, {
        children: [/*#__PURE__*/_jsx("div", {
          children: "Bonjour"
        }), firstName && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: ",\xA0"
          }), /*#__PURE__*/_jsx("b", {
            children: firstName
          })]
        })]
      }), /*#__PURE__*/_jsx(ProfileLink, {
        href: "https://www.rts.ch/profile",
        children: "Mon profil"
      })]
    })]
  });
};
const Greeting = styled.div.withConfig({
  displayName: "RTSLoginProfile__Greeting",
  componentId: "sc-so0j36-0"
})(["display:flex;color:", ";"], Colors.WHITE);
const ProfileLink = styled.a.withConfig({
  displayName: "RTSLoginProfile__ProfileLink",
  componentId: "sc-so0j36-1"
})(["color:", ";", ";line-height:24px;"], Colors.BLUE_6199E3, Fonts.regular(16));
const Layout = styled.div.withConfig({
  displayName: "RTSLoginProfile__Layout",
  componentId: "sc-so0j36-2"
})(["display:grid;grid-template-columns:40px 1fr;grid-auto-flow:row;grid-column-gap:16px;padding:4px;margin-right:20px;"]);
const PersonalSection = styled.section.withConfig({
  displayName: "RTSLoginProfile__PersonalSection",
  componentId: "sc-so0j36-3"
})(["display:grid;", ";line-height:24px;"], Fonts.regular(16));